export enum AuthorityEmployeeCommission {
  VIEW_EMPLOYEE_COMMISSION = '2.8.0',
  INCREASE_COMMISSION_ABOVE_REGISTERED_LIMIT = '2.8.1',
  VIEW_TOTAL_BASE_VALUE_AND_TOTAL_COMISSION_IN_BUDGET = '2.8.2',
  MOVIMENTATION_WORK_ORDER_ALLOW_TO_ENTER_ITEM_SALES_VALUE_BELOW_PROFIT_MARGIN = '2.8.3',
  MOVIMENTATION_WORKORDER_VIEW_CHECKLIST = '2.8.4',
  MOVIMENTATION_WORKORDER_PRINT_CHECKLIST = '2.8.5',
  MOVIMENTATION_WORKORDER_EDIT_ENTRY_DATE = '2.8.6',
}
